// extracted by mini-css-extract-plugin
export var brand = "_30-9";
export var compact = "_30-6";
export var extraSmall = "_30-7";
export var icon = "_30-0";
export var large = "_30-4";
export var light = "_30-1";
export var medium = "_30-5";
export var outline = "_30-b";
export var primaryDark = "_30-a";
export var primaryLight = "_30-8";
export var primaryModern = "_30-c";
export var success = "_30-2";
export var successSolid = "_30-3";